import styles from "./toolbar-design-system.module.css";
import React from "react";

export const straightLine = (
  <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="23.5472" y1="5.51296" x2="8.54715" y2="21.513" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
export const notDashedLine = (
  <svg width="23" height="2" viewBox="0 0 23 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.25H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
export const largeDashedLine = (
  <svg width="23" height="2" viewBox="0 0 23 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.25H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4" />
  </svg>
);
export const smallDashedLine = (
  <svg width="23" height="2" viewBox="0 0 23 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="0.75" cy="0.75" r="0.75" fill="currentColor" />
    <circle cx="3.75" cy="0.75" r="0.75" fill="currentColor" />
    <circle cx="6.75" cy="0.75" r="0.75" fill="currentColor" />
    <circle cx="9.75" cy="0.75" r="0.75" fill="currentColor" />
    <circle cx="12.75" cy="0.75" r="0.75" fill="currentColor" />
    <circle cx="15.75" cy="0.75" r="0.75" fill="currentColor" />
    <circle cx="18.75" cy="0.75" r="0.75" fill="currentColor" />
    <circle cx="21.75" cy="0.75" r="0.75" fill="currentColor" />
  </svg>
);
export const curvedLine = (
  <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 21H9.44444C19.5 21 12.5 6 22.7778 6H24" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
export const elbowLine = (
  <svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.2857 5L24 5" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M20.3279 5L16.1437 5L16.1437 20.6096L14.1078 20.6096L12.0719 20.6096H8"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const mindmapHorizontalOrientation = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1536 13.3114C18.4495 13.8976 18.6046 14.55 18.6047 15.2131L18.6047 19.1711L20 19.1711L20 15.2131C19.9999 14.333 19.7943 13.4651 19.3993 12.6826C19.0043 11.9001 18.4311 11.2251 17.7266 10.7163L12.3926 6.8638C11.8718 6.48773 11.4445 5.9861 11.1487 5.39997C10.8531 4.81431 10.698 4.1625 10.6977 3.50002C10.6977 3.49944 10.6977 3.49886 10.6977 3.49828L10.6977 3.49818L10.6977 0.5L9.30233 0.5L9.30233 3.49818L9.30233 3.49828C9.30233 3.49886 9.30233 3.49944 9.30233 3.50002C9.30198 4.1625 9.14692 4.81432 8.85132 5.39997C8.55549 5.9861 8.12817 6.48773 7.60738 6.8638L2.27342 10.7163C1.56888 11.2251 0.995651 11.9001 0.600681 12.6826C0.205743 13.4651 6.42452e-05 14.333 -6.43128e-07 15.2131L-8.1614e-07 19.1711L1.39535 19.1711L1.39535 15.2131C1.3954 14.55 1.55048 13.8976 1.84635 13.3114C2.14219 12.7252 2.56951 12.2236 3.0903 11.8475L8.42425 7.99504C8.76492 7.74904 9.07488 7.46416 9.34884 7.14705L9.34884 19.4036L10.7442 19.4036L10.7442 7.25198C10.9947 7.52724 11.2731 7.77648 11.5757 7.99504L16.9097 11.8475C17.4305 12.2236 17.8578 12.7252 18.1536 13.3114Z"
      fill="currentColor"
    />
  </svg>
);

export const mindmapVerticalOrientation = (
  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8114 1.84635C13.3976 1.55048 14.05 1.39541 14.7131 1.39535L18.6711 1.39535V0L14.7131 0C13.833 6.44285e-05 12.9651 0.205744 12.1826 0.600682C11.4001 0.995652 10.7251 1.56888 10.2163 2.27342L6.3638 7.60738C5.98773 8.12817 5.4861 8.55549 4.89997 8.85132C4.31432 9.14692 3.6625 9.30198 3.00002 9.30233C2.99944 9.30233 2.99886 9.30233 2.99828 9.30233L2.99818 9.30233H0L0 10.6977L2.99818 10.6977L2.99828 10.6977C2.99886 10.6977 2.99944 10.6977 3.00002 10.6977C3.6625 10.698 4.31432 10.8531 4.89997 11.1487C5.4861 11.4445 5.98773 11.8718 6.3638 12.3926L10.2163 17.7266C10.7251 18.4311 11.4001 19.0043 12.1826 19.3993C12.9651 19.7943 13.833 19.9999 14.7131 20H18.6711V18.6047H14.7131C14.05 18.6046 13.3976 18.4495 12.8114 18.1536C12.2252 17.8578 11.7236 17.4305 11.3475 16.9097L7.49504 11.5757C7.24904 11.2351 6.96416 10.9251 6.64705 10.6512L18.9036 10.6512L18.9036 9.25581L6.75198 9.25581C7.02724 9.00534 7.27648 8.72691 7.49504 8.42425L11.3475 3.0903C11.7236 2.56951 12.2252 2.14219 12.8114 1.84635Z"
      fill="currentColor"
    />
  </svg>
);

export function ButtonRow({ children }: React.PropsWithChildren<unknown>) {
  return <div className={styles.buttonRow}>{children}</div>;
}

export function Stack({ children }: React.PropsWithChildren<unknown>) {
  return <div className={styles.stack}>{children}</div>;
}
